import { Skeleton } from '@mui/material';
import { ReactNode } from 'react';

interface IProps {
  loading: boolean;
  children: ReactNode;
  skeletonWidth?: string | number;
  skeletonHeight?: string | number;
}

const LoadingCellWrapper = ({ loading, children, skeletonWidth = '80%', skeletonHeight = '80%' }: IProps) =>
  loading ? <Skeleton width={skeletonWidth} height={skeletonHeight} /> : children;

export default LoadingCellWrapper;
